import React, { useEffect } from "react";
import { Lazy } from "@/components/Lazy";
import { QREditorContextProps, QRProps } from "@/contexts/QREditorContext/types";
import { QREditorContext } from "@/contexts/QREditorContext";
import { QRSocialMedia } from "@/types/qr";
import { PreviewLayout } from ".";
import { Typography } from "../Typography";
import { SocialMediaBlock } from "../SocialMediaBlock";
import { optimizeCloudinaryImage } from "@/services/CloudinaryService";

export default function PreviewSocial(props: QRProps<"social">) {
  const qrEditorContextData = React.useContext<QREditorContextProps<"social">>(QREditorContext);
  const data = props?.data || qrEditorContextData?.qrData.data;
  const { logoUrl, themeColor, headline, description } = data;
  const isInitPreview = props?.initPreview;

  useEffect(() => {
    if (!isInitPreview) {
      const socialsExist = data.links && data.links.length > 0;
      !socialsExist
        ? qrEditorContextData.setValidationError(true)
        : qrEditorContextData.setValidationError(false);
    }
  }, [data]);

  const renderImage = () => {
    if (!logoUrl) {
      return null;
    }

    const imageSrc = isInitPreview
      ? logoUrl
      : optimizeCloudinaryImage({
          url: logoUrl,
          transformations: ["f_auto,q_auto,w_1280,h_640,dpr_auto,c_fill"],
        });

    return (
      <Lazy placeholderClass="skeleton-placeholder__links__image">
        <img
          src={imageSrc}
          alt={"social preview"}
        />
      </Lazy>
    );
  };

  const renderSocialMedia = () => {
    const { links }: { links: QRSocialMedia[] } = data;
    if (!links || links.length === 0) {
      return null;
    }

    return links.map((link) => {
      return (
        <SocialMediaBlock
          key={link.id}
          socialNetwork={link}
        />
      );
    });
  };

  return (
    <PreviewLayout
      page="social"
      dataQA="preview-image-container"
      includeBrowser
      isInitPreview={isInitPreview}>
      <div
        className="qr-content"
        style={{
          backgroundColor: themeColor?.backgroundColor,
        }}>
        {renderImage()}
        <div className="qr-text">
          <Typography
            Tag="p"
            size="l"
            classname="u-bold u-spacing-0 qr-text__title">
            {headline}
          </Typography>
          {description && (
            <Typography
              Tag="p"
              size="s"
              classname="u-spacing-0">
              {description}
            </Typography>
          )}
        </div>
        <div
          className="divider"
          style={{
            backgroundColor: themeColor?.buttonColor,
          }}
        />
        {renderSocialMedia()}
      </div>
    </PreviewLayout>
  );
}
